import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'
import groups from '@/store/modules/groups'
import people from '@/store/modules/people'
import axios from 'axios'
import router from '../router'

const apiEndpoint = process.env.VUE_APP_GRAPHQL_ENDPOINT

Vue.use(Vuex)

function getReferrer() {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search)
    const referrer = urlParams.get('referrer') || document.referrer
    if (
      referrer &&
      (referrer.includes('asd20.org') ||
        referrer.includes('asd20communicator.org'))
    ) {
      return referrer.replace(/\/$/, '')
    }
  }
  return 'https://asd20.org'
}

const state = {
  keywords: '',
  organizations: [],
  selectedOrganizationId: null,
  referrer: getReferrer(),
  // ID to exclude
  excludedOrganizationId: '7ab6f0b0-3304-11ef-92d6-ed16a99dd422',
}

const store = new Vuex.Store({
  plugins: [pathify.plugin],
  modules: { groups, people },

  state,

  mutations: make.mutations(state),

  actions: {
    ...make.actions(state),

    async setSelectedOrganizationId(
      { commit, dispatch },
      selectedOrganizationId
    ) {
      commit('SET_SELECTED_ORGANIZATION_ID', selectedOrganizationId)
      dispatch('groups/getGroups')
    },

    async getOrganizations({ commit }) {
      const { data } = await axios.post(`${apiEndpoint}`, {
        query: `{
          organizations(order_by: { title: asc }, where: { id: { _neq: "${state.excludedOrganizationId}" } }) {
            id
            title
            abbreviation
            educationLevels
            logoImageUrl
          }
        }`,
      })
      const organizations = (data && data.data && data.data.organizations) || []

      commit('SET_ORGANIZATIONS', organizations)
    },
  },

  getters: {
    selectedOrganization: state => {
      return state.organizations.find(
        o => o.id === state.selectedOrganizationId
      )
    },
    organizationOptions: state => {
      return (state.organizations || []).map(o => ({
        text: o.title,
        value: o.id,
      }))
    },
  },

  strict: process.env.NODE_ENV !== 'production',
})

store.watch(
  (state, getters) => {
    return getters.selectedOrganization
  },
  ({ abbreviation }) => {
    const sanitizedAbbreviation = abbreviation
      .toLowerCase()
      .replace('asd20', 'district')
    if (router.currentRoute.params.abbreviation !== sanitizedAbbreviation) {
      router.push({
        name: router.currentRoute.name,
        params: {
          ...router.currentRoute.params,
          abbreviation: sanitizedAbbreviation,
        },
      })
    }
  }
)

export default store
